
import ApiConstants from "../constants/ApiConstants";
import http from "../http";
class LocationListService {
  static getLocationList() {
    const finalEndpoint: string = `${
      ApiConstants.URL.BASE + ApiConstants.URL.LOCATION.GET_LOCATION_LIST
    }`;
    return http
      .get(`${finalEndpoint}`)
      .then(
        (response: any) => {
          return Promise.resolve(response);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      )
      .catch((error: any) => {
        return Promise.reject(error);
      });
  }

  static getLocationDimentionList() {
    const finalEndpoint: string = `${
      ApiConstants.URL.BASE + ApiConstants.URL.LOCATION.GET_LOCATION_DIMENTION_LIST
    }`;
    return http
      .get(`${finalEndpoint}`)
      .then(
        (response: any) => {
          return Promise.resolve(response);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      )
      .catch((error: any) => {
        return Promise.reject(error);
      });
  }

  static updateLocation(params) {
    const finalEndpoint: string = `${
      ApiConstants.URL.BASE +
      ApiConstants.URL.LOCATION.UPDATE_LOCATION(params.id)
    }`;
    return http
      .put(`${finalEndpoint}`, params)
      .then(
        (response: any) => {
          return Promise.resolve(response);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      )
      .catch((error: any) => {
        return Promise.reject(error);
      });
  }

  static saveLocation(params) {
    const finalEndpoint: string = `${
      ApiConstants.URL.BASE + ApiConstants.URL.LOCATION.GET_LOCATION_LIST
    }`;
    return http
      .post(`${finalEndpoint}`, params)
      .then(
        (response: any) => {
          return Promise.resolve(response);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      )
      .catch((error: any) => {
        return Promise.reject(error);
      });
  }

  static saveLocationSettings(params) {
    const finalEndpoint: string = `${
      ApiConstants.URL.BASE + ApiConstants.URL.TENANT.ERP_TENANT
    }`;
    return http
      .patch(`${finalEndpoint}`, params)
      .then(
        (response: any) => {
          return Promise.resolve(response);
        },
        (error: any) => {
          return Promise.reject(error);
        }
      )
      .catch((error: any) => {
        return Promise.reject(error);
      });
  }
}

export default LocationListService;